<script>
  import { onMount } from "svelte";
  import {
    API_DIR,
    SESSION_LS,
    selectedDeviceId,
    selectedDevices,
    selectedPage,
    showLoadingModal,
    tableData,
    HARWARE_INFO
  } from "../store";
  //import { sortedJsonData } from "../Tables/tableData";
  import { Tabs, TabList, TabPanel, Tab } from "../Tabs/tabs";
  import { convertUnixToDate } from "../Utils.svelte";
  import { toasts } from "svelte-toasts";

  //let responseJsonData = sortedJsonData();
  let selectedDeviceObjs = $selectedDevices[0];
  //console.log(selectedDeviceObjs);
  let deviceHistory = [];
  let firmwareHistory = [];
  let configHistory = [];
  let jpodConfigHistory = [];
  let jpodFirmwareHistory = [];
  let isMounted = false;
  let notAllowedKeysFirmware = [
    "filename",
    "update_id",
    "job_id",
    "auth",
    "act_type",
    "app_id",
    "id_group",
    "index",
    "group_lenght"
  ];

  let notAllowedKeysConfig = [
    "filename",
    "update_id",
    "job_id",
    "auth",
    "act_type",
    "app_id",
    "id_group",
    "index",
    "act_type",
    "firmware",
    "script"
  ];

  let notAllowedKeysJpodConfig = [
    "filename",
    "update_id",
    "job_id",
    "auth",
    "act_type",
    "app_id",
    "id_group",
    "index",
    "act_type",
    "firmware",
    "config",
    "script"
  ];

  //$: $selectedDeviceId, getJsonObjs();

  /*function getJsonObjs() {
    if ($selectedDeviceId.length == 1) {
      selectedDeviceObjs = $tableData.find(
        (obj) => obj.id_device === $selectedDeviceId[0].toString() //todo: puedo pasar todo el row desde la página anterior
      );
    }
  }*/

  function getHardwareInfo() {
    let hardwareInfo = $HARWARE_INFO;
    let hardwareInfoObj = hardwareInfo.find(
      (obj) => obj.APPID == selectedDeviceObjs.app_id
    );

    //console.log("HARDWARE INFO", hardwareInfoObj);
    if (hardwareInfoObj) {
      selectedDeviceObjs.modem = hardwareInfoObj.MODEM_SELECT;
      selectedDeviceObjs.parts = hardwareInfoObj.PART_INFO;
    }

    //console.log("DEVICE INFO", selectedDeviceObjs);
  }

  async function cancelUpdate(jobId) {
    const confirmation = confirm(
      "Are you sure you want to cancel this update queue?"
    );

    if (!confirmation) {
      return;
    }

    try {
      showLoadingModal.set(true);

      const response = await fetch(`${$API_DIR}/api/v1/set-update-status`, {
        method: "POST",
        body: JSON.stringify({ update_id: jobId, new_status: "canceled" }),
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem("session_id")
        }
      });

      showLoadingModal.set(false);

      if (response.status === 401) {
        location.reload();
      }

      if (!response.ok) {
        toasts.error("Could not cancel update");
      }

      if (response.ok) {
        toasts.success("Update canceled");
        fetchData();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getDeviceUpdates(deviceId) {
    const url = `${$API_DIR}/api/v1/get-device-updates?id_device=${deviceId}`;

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Session-Id": localStorage.getItem($SESSION_LS)
      }
    };

    try {
      const response = await fetch(url, requestOptions);

      if (response.ok) {
        const data = await response.json();
        //console.log("Firmware updates retrieved:", data);
        return data;
      } else if (response.status === 401) {
        location.reload();
      } else {
        console.log("Error retrieving device updates");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function fetchData() {
    deviceHistory = await getDeviceUpdates(selectedDeviceObjs.id_device);
    console.log(deviceHistory);
    firmwareHistory = deviceHistory.firmware_updates || [];
    configHistory = deviceHistory.config_updates || [];
    jpodConfigHistory = deviceHistory.jpod_config_updates || [];
    jpodFirmwareHistory = deviceHistory.jpod_firmware_updates || [];

    firmwareHistory.forEach((update) => {
      if (!update.hasOwnProperty("tag_group")) {
        update.tag_group = "-";
      }
    });
    //console.log(deviceHistory);
    //console.log(firmwareHistory);
  }

  getHardwareInfo();

  onMount(async () => {
    fetchData();

    const interval = setInterval(fetchData, 20 * 1000); //recargar data de la tabla
    isMounted = true;

    return () => {
      clearInterval(interval);
    };
  });
</script>

<div>
  <hr />
  <div class="row">
    <div class="col-lg-6">
      <h3>Device detail for: {selectedDeviceObjs.id_device}</h3>
    </div>

    <div class="d-flex flex-row-reverse bd-highlight col-lg-6">
      <button
        type="button"
        class="btn btn-outline-danger"
        style="margin-left: 16px;"
        on:click={() => {
          selectedPage.set(3);
        }}><i class="bi bi-x-square" /> Cancel</button
      >

      <!--<button
        id="btn-device-firmware"
        type="button"
        class="btn btn-secondary p-2 bd-highlight"
        style="margin-left:16px"
        on:click={() => {
          selectedPage.set(2);
        }}
      >
        <i class="bi bi-cpu-fill" /> Firmware</button
      >

      <button
        id="btn-device-config"
        type="button"
        class="btn btn-primary p-2 bd-highlight"
        style="margin-left:16px"
        on:click={() => {
          selectedPage.set(7);
        }}
      >
        <i class="bi bi-gear-fill" /> Config</button
      >-->

      <button
        id="btn-task"
        type="button"
        class="btn btn-primary"
        style="margin-left:16px"
        on:click={() => {
          selectedPage.set(10);
        }}
      >
        <i class="bi bi-list-ol"></i> Tasks</button
      >
    </div>
  </div>
  <hr />

  <div class="">
    <table class="table table-striped table-hover table-bordered table-sm">
      <thead class="thead-dark">
        <tr>
          <th scope="col">DATA</th>
          <th scope="col">VALUE</th>
        </tr>
      </thead>
      <tbody>
        {#each Object.keys(selectedDeviceObjs) as data}
          {#if data == "VBUS"}
            <tr>
              <th scope="row">VBUS TYPE | VBUS BoardID</th>
              <td
                >JPOd | <button
                  type="button"
                  class="btn btn-link"
                  on:click={() => {}}
                >
                  {selectedDeviceObjs[data].split(",")[2]}
                </button></td
              >
            </tr>
          {:else}
            <tr>
              <th scope="row">{data.toUpperCase()}</th>
              <td>{selectedDeviceObjs[data]}</td>
            </tr>
          {/if}
        {/each}
      </tbody>
    </table>
  </div>

  <!--<div class="">
      <br>
      <hr>
      <h4>ID Report Details</h4>
      <hr>
      <div class="accordion" id="accordionReports">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFileHash">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFileHash"
              aria-expanded="false"
              aria-controls="collapseFileHash"
            >
              FileHash Table
            </button>
          </h2>
          <div
            id="collapseFileHash"
            class="accordion-collapse collapse"
            aria-labelledby="headingFileHash"
            data-bs-parent="#accordionReports"
          >
            <div class="accordion-body">
              <strong>This is the first item's accordion body.</strong> It is
              shown by default, until the collapse plugin adds the appropriate
              classes that we use to style each element. These classes control
              the overall appearance, as well as the showing and hiding via CSS
              transitions. You can modify any of this with custom CSS or
              overriding our default variables. It's also worth noting that just
              about any HTML can go within the <code>.accordion-body</code>,
              though the transition does limit overflow.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingUnknownExtensions">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseUnknownExtensions"
              aria-expanded="false"
              aria-controls="collapseUnknownExtensions"
            >
              Unknown Extensions
            </button>
          </h2>
          <div
            id="collapseUnknownExtensions"
            class="accordion-collapse collapse"
            aria-labelledby="headingUnknownExtensions"
            data-bs-parent="#accordionReports"
          >
            <div class="accordion-body">
              <strong>This is the second item's accordion body.</strong> It is
              hidden by default, until the collapse plugin adds the appropriate
              classes that we use to style each element. These classes control
              the overall appearance, as well as the showing and hiding via CSS
              transitions. You can modify any of this with custom CSS or
              overriding our default variables. It's also worth noting that just
              about any HTML can go within the <code>.accordion-body</code>,
              though the transition does limit overflow.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingParsedExtensions">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseParsedExtensions"
              aria-expanded="false"
              aria-controls="collapseParsedExtensions"
            >
              Parsed Extensions
            </button>
          </h2>
          <div
            id="collapseParsedExtensions"
            class="accordion-collapse collapse"
            aria-labelledby="headingParsedExtensions"
            data-bs-parent="#accordionReports"
          >
            <div class="accordion-body">
              <strong>This is the third item's accordion body.</strong> It is
              hidden by default, until the collapse plugin adds the appropriate
              classes that we use to style each element. These classes control
              the overall appearance, as well as the showing and hiding via CSS
              transitions. You can modify any of this with custom CSS or
              overriding our default variables. It's also worth noting that just
              about any HTML can go within the <code>.accordion-body</code>,
              though the transition does limit overflow.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOtaCpability">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOtaCpability"
              aria-expanded="false"
              aria-controls="collapseOtaCpability"
            >
              Ota Capability
            </button>
          </h2>
          <div
            id="collapseOtaCpability"
            class="accordion-collapse collapse"
            aria-labelledby="headingOtaCpability"
            data-bs-parent="#accordionReports"
          >
            <div class="accordion-body">
              <strong>This is the third item's accordion body.</strong> It is
              hidden by default, until the collapse plugin adds the appropriate
              classes that we use to style each element. These classes control
              the overall appearance, as well as the showing and hiding via CSS
              transitions. You can modify any of this with custom CSS or
              overriding our default variables. It's also worth noting that just
              about any HTML can go within the <code>.accordion-body</code>,
              though the transition does limit overflow.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOtaStatus">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOtaStatus"
              aria-expanded="false"
              aria-controls="collapseOtaStatus"
            >
              OtaStatus
            </button>
          </h2>
          <div
            id="collapseOtaStatus"
            class="accordion-collapse collapse"
            aria-labelledby="headingOtaStatus"
            data-bs-parent="#accordionReports"
          >
            <div class="accordion-body">
              <strong>This is the third item's accordion body.</strong> It is
              hidden by default, until the collapse plugin adds the appropriate
              classes that we use to style each element. These classes control
              the overall appearance, as well as the showing and hiding via CSS
              transitions. You can modify any of this with custom CSS or
              overriding our default variables. It's also worth noting that just
              about any HTML can go within the <code>.accordion-body</code>,
              though the transition does limit overflow.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingVbusReport">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseVbusReport"
              aria-expanded="false"
              aria-controls="collapseVbusReport"
            >
              Vbus Report
            </button>
          </h2>
          <div
            id="collapseVbusReport"
            class="accordion-collapse collapse"
            aria-labelledby="headingVbusReport"
            data-bs-parent="#accordionReports"
          >
            <div class="accordion-body">
              <strong>This is the third item's accordion body.</strong> It is
              hidden by default, until the collapse plugin adds the appropriate
              classes that we use to style each element. These classes control
              the overall appearance, as well as the showing and hiding via CSS
              transitions. You can modify any of this with custom CSS or
              overriding our default variables. It's also worth noting that just
              about any HTML can go within the <code>.accordion-body</code>,
              though the transition does limit overflow.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingDeviceServices">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseDeviceServices"
              aria-expanded="false"
              aria-controls="collapseDeviceServices"
            >
              Device Services
            </button>
          </h2>
          <div
            id="collapseDeviceServices"
            class="accordion-collapse collapse"
            aria-labelledby="headingDeviceServices"
            data-bs-parent="#accordionReports"
          >
            <div class="accordion-body">
              <strong>This is the third item's accordion body.</strong> It is
              hidden by default, until the collapse plugin adds the appropriate
              classes that we use to style each element. These classes control
              the overall appearance, as well as the showing and hiding via CSS
              transitions. You can modify any of this with custom CSS or
              overriding our default variables. It's also worth noting that just
              about any HTML can go within the <code>.accordion-body</code>,
              though the transition does limit overflow.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingRadioState">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRadioState"
              aria-expanded="false"
              aria-controls="collapseRadioState"
            >
              Radio State
            </button>
          </h2>
          <div
            id="collapseRadioState"
            class="accordion-collapse collapse"
            aria-labelledby="headingRadioState"
            data-bs-parent="#accordionReports"
          >
            <div class="accordion-body">
              <strong>This is the third item's accordion body.</strong> It is
              hidden by default, until the collapse plugin adds the appropriate
              classes that we use to style each element. These classes control
              the overall appearance, as well as the showing and hiding via CSS
              transitions. You can modify any of this with custom CSS or
              overriding our default variables. It's also worth noting that just
              about any HTML can go within the <code>.accordion-body</code>,
              though the transition does limit overflow.
            </div>
          </div>
        </div>
      </div>
    </div>-->

  <!--TABS-->
  <br />
  <hr />
  <h4>History</h4>
  <hr />

  <Tabs>
    <TabList>
      <Tab>FIRMWARE</Tab>
      <Tab>CONFIG</Tab>
      {#if selectedDeviceObjs.VBUS != undefined}
        <Tab>JPOD CONFIG</Tab>
        <Tab>JPOD FW</Tab>
      {/if}
    </TabList>

    <TabPanel
      ><!--firmware-->

      <h3>FIRMWARE</h3>

      {#if isMounted}
        {#if firmwareHistory.length > 0}
          <br />

          <div style="max-height: 400px; overflow-y: auto;">
            <table
              class="table table-hover table-sm table-bordered table-striped table-responsive"
            >
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">VERSION</th>
                  <th scope="col">DATE CREATED</th>
                  <th scope="col">DATE UPDATED</th>
                  <th scope="col">STATUS</th>
                  <th scope="col">CAMPAIGN</th>
                </tr>
              </thead>
              <tbody>
                {#each firmwareHistory.slice().reverse() as item, index}
                  <tr>
                    <!--<th scope="row">{index + 1}</th>-->
                    <th scope="row">{firmwareHistory.length - 1 * index}</th>
                    {#each Object.entries(item) as [key, value]}
                      {#if !notAllowedKeysFirmware.includes(key)}
                        <td>
                          {#if key === "date_created" || key === "date_updated"}
                            {convertUnixToDate(value)}
                          {:else if key === "status"}
                            <div class="d-flex justify-content-center">
                              {#if value == "discovered"}
                                <div
                                  class="badge bg-primary"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {:else if value == "created"}
                                <button
                                  class="badge cretedButton"
                                  style="max-height: 20.4px;"
                                  on:mouseenter={(e) => {
                                    e.target.textContent = "CANCEL";
                                  }}
                                  on:mouseleave={(e) => {
                                    e.target.textContent = "CREATED";
                                  }}
                                  on:click={() => {
                                    cancelUpdate(item.job_id);
                                  }}
                                >
                                  {value.toUpperCase()}
                                </button>
                                <!--<div
                                  class=" d-flex align-items-center justify-content-center badge bg-primary"
                                  style="width: 90px; max-height: 20.4px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                                <div
                                  style="margin-left: 5px; max-height: 20.4px; margin-top: -2.4px"
                                >
                                  <button
                                    class="badge bg-danger"
                                    style="max-height: 20.4px;"
                                    on:click={() => {
                                      cancelUpdate(item.job_id);
                                    }}
                                  >
                                    X
                                  </button>
                                </div>-->
                              {:else if value == "failed"}
                                <div
                                  class="badge bg-danger"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {:else if value == "processing"}
                                <div
                                  class="badge bg-warning"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {:else if value == "canceled"}
                                <div
                                  class="badge bg-danger"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {:else if value == "completed"}
                                <div
                                  class="badge bg-success"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {/if}
                            </div>
                          {:else}
                            {value !== undefined ? value : "No data"}
                          {/if}
                        </td>
                      {/if}

                      <!--{#if value == "created"}
                        <td>
                          <button
                            class="badge bg-danger"
                            on:click={() => {
                              cancelUpdate(item.job_id);
                            }}
                          >
                            <i class="bi bi-x-square" />
                          </button>
                        </td>
                      {/if}-->
                    {/each}
                  </tr>
                {/each}
              </tbody>
            </table>
          </div>
        {:else}
          <br />
          <h5>No existing records yet</h5>
        {/if}
      {/if}
    </TabPanel>

    <TabPanel>
      <h3>CONFIG</h3>

      {#if isMounted}
        {#if configHistory.length > 0}
          <br />

          <div style="max-height: 400px; overflow-y: auto;">
            <table
              class="table table-hover table-sm table-bordered table-striped table-responsive"
            >
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">VERSION</th>
                  <th scope="col">DATE CREATED</th>
                  <th scope="col">DATE UPDATED</th>
                  <th scope="col">STATUS</th>
                  <th scope="col">CAMPAIGN</th>
                </tr>
              </thead>
              <tbody>
                {#each configHistory.slice().reverse() as item, index}
                  <tr>
                    <!--<th scope="row">{index + 1}</th>-->
                    <th scope="row">{configHistory.length - 1 * index}</th>
                    {#each Object.entries(item) as [key, value]}
                      {#if !notAllowedKeysConfig.includes(key)}
                        <td>
                          {#if key === "config" || key === "script"}
                            {#if item.config && item.script}
                              {item.script} - {item.config}
                            {/if}
                          {:else if key === "date_created" || key === "date_updated"}
                            {convertUnixToDate(value)}
                          {:else if key === "version"}
                            {value}
                          {:else if key === "status"}
                            <div class="d-flex justify-content-center">
                              {#if value == "discovered"}
                                <div
                                  class="badge bg-primary"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {:else if value == "created"}
                                <button
                                  class="badge cretedButton"
                                  style="max-height: 20.4px;"
                                  on:mouseenter={(e) => {
                                    e.target.textContent = "CANCEL";
                                  }}
                                  on:mouseleave={(e) => {
                                    e.target.textContent = "CREATED";
                                  }}
                                  on:click={() => {
                                    cancelUpdate(item.job_id);
                                  }}
                                >
                                  {value.toUpperCase()}
                                </button>
                              {:else if value == "failed"}
                                <div
                                  class="badge bg-danger"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {:else if value == "canceled"}
                                <div
                                  class="badge bg-danger"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {:else if value == "processing"}
                                <div
                                  class="badge bg-warning"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {:else if value == "completed"}
                                <div
                                  class="badge bg-success"
                                  style="width: 120px;"
                                >
                                  {value.toUpperCase()}
                                </div>
                              {/if}
                            </div>
                          {:else}
                            {value !== undefined ? value : "No data"}
                          {/if}
                        </td>
                      {/if}
                    {/each}
                  </tr>
                {/each}
              </tbody>
            </table>
          </div>
        {:else}
          <br />
          <h5>No existing records yet</h5>
        {/if}
      {/if}
    </TabPanel>

    {#if selectedDeviceObjs.VBUS != undefined}
      <TabPanel>
        <h3>JPOD CONFIG</h3>

        {#if isMounted}
          {#if configHistory.length > 0}
            <br />

            <div style="max-height: 400px; overflow-y: auto;">
              <table
                class="table table-hover table-sm table-bordered table-striped table-responsive"
              >
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">VERSION</th>
                    <th scope="col">DATE CREATED</th>
                    <th scope="col">DATE UPDATED</th>
                    <th scope="col">STATUS</th>
                    <th scope="col">CAMPAIGN</th>
                  </tr>
                </thead>
                <tbody>
                  {#each jpodConfigHistory.slice().reverse() as item, index}
                    <tr>
                      <!--<th scope="row">{index + 1}</th>-->
                      <th scope="row">{jpodConfigHistory.length - 1 * index}</th
                      >
                      {#each Object.entries(item) as [key, value]}
                        {#if !notAllowedKeysJpodConfig.includes(key)}
                          <td>
                            <!--{#if key === "config" || key === "script"}-->
                            <!-- {#if key === "config" || key === "script"}
                              {#if item.config}
                                {item.script} - {item.config}
                              {/if}
                            {:else if key === "date_created" || key === "date_updated"}-->

                            {#if key === "version"}
                              {value}
                            {:else if key === "date_created" || key === "date_updated"}
                              {convertUnixToDate(value)}
                            {:else if key === "status"}
                              <div class="d-flex justify-content-center">
                                {#if value == "discovered"}
                                  <div
                                    class="badge bg-primary"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {:else if value == "created"}
                                  <button
                                    class="badge cretedButton"
                                    style="max-height: 20.4px;"
                                    on:mouseenter={(e) => {
                                      e.target.textContent = "CANCEL";
                                    }}
                                    on:mouseleave={(e) => {
                                      e.target.textContent = "CREATED";
                                    }}
                                    on:click={() => {
                                      cancelUpdate(item.job_id);
                                    }}
                                  >
                                    {value.toUpperCase()}
                                  </button>
                                {:else if value == "failed"}
                                  <div
                                    class="badge bg-danger"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {:else if value == "canceled"}
                                  <div
                                    class="badge bg-danger"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {:else if value == "processing"}
                                  <div
                                    class="badge bg-warning"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {:else if value == "completed"}
                                  <div
                                    class="badge bg-success"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {/if}
                              </div>
                            {:else}
                              {value !== undefined ? value : "No data"}
                            {/if}
                          </td>
                        {/if}
                      {/each}
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          {:else}
            <br />
            <h5>No existing records yet</h5>
          {/if}
        {/if}
      </TabPanel>

      <TabPanel>
        <h3>JPOD FW</h3>

        {#if isMounted}
          {#if jpodFirmwareHistory.length > 0}
            <br />

            <div style="max-height: 400px; overflow-y: auto;">
              <table
                class="table table-hover table-sm table-bordered table-striped table-responsive"
              >
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">VERSION</th>
                    <th scope="col">DATE CREATED</th>
                    <th scope="col">DATE UPDATED</th>
                    <th scope="col">STATUS</th>
                    <th scope="col">CAMPAIGN</th>
                  </tr>
                </thead>
                <tbody>
                  {#each jpodFirmwareHistory.slice().reverse() as item, index}
                    <tr>
                      <!--<th scope="row">{index + 1}</th>-->
                      <th scope="row"
                        >{jpodFirmwareHistory.length - 1 * index}</th
                      >
                      {#each Object.entries(item) as [key, value]}
                        {#if !notAllowedKeysFirmware.includes(key)}
                          <td>
                            {#if key === "date_created" || key === "date_updated"}
                              {convertUnixToDate(value)}
                            {:else if key === "status"}
                              <div class="d-flex justify-content-center">
                                {#if value == "discovered"}
                                  <div
                                    class="badge bg-primary"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {:else if value == "created"}
                                  <button
                                    class="badge cretedButton"
                                    style="max-height: 20.4px;"
                                    on:mouseenter={(e) => {
                                      e.target.textContent = "CANCEL";
                                    }}
                                    on:mouseleave={(e) => {
                                      e.target.textContent = "CREATED";
                                    }}
                                    on:click={() => {
                                      cancelUpdate(item.job_id);
                                    }}
                                  >
                                    {value.toUpperCase()}
                                  </button>
                                {:else if value == "failed"}
                                  <div
                                    class="badge bg-danger"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {:else if value == "processing"}
                                  <div
                                    class="badge bg-warning"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {:else if value == "canceled"}
                                  <div
                                    class="badge bg-danger"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {:else if value == "completed"}
                                  <div
                                    class="badge bg-success"
                                    style="width: 120px;"
                                  >
                                    {value.toUpperCase()}
                                  </div>
                                {/if}
                              </div>
                            {:else}
                              {value !== undefined ? value : "No data"}
                            {/if}
                          </td>
                        {/if}
                      {/each}
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          {:else}
            <br />
            <h5>No existing records yet</h5>
          {/if}
        {/if}
      </TabPanel>
    {/if}
  </Tabs>
</div>

<style>
  .cretedButton {
    background-color: #007bff;
    color: white;
    border: none;
    width: 120px;
  }

  .cretedButton:hover {
    background-color: #dc3545;
    color: white;
  }
</style>
